import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoadlabasimagicainnova() {



const cardData = {
keyword: "Pune to Adlabs Imagica Innova Crysta Cab",
headingDescription: "Enjoy a comfortable and convenient journey from Pune to Adlabs Imagica in a spacious Innova Crysta cab with Citysky Cabs. The service is suitable for families, friends and groups planning a theme park visit, weekend outing or one-day trip. With air-conditioned interiors, comfortable seating, generous luggage space and a private driver, travellers can enjoy a relaxed road journey to Imagica and return to Pune without depending on shared transportation.",
topPlaces: [
{
title: "Adlabs Imagica Theme Park",
description: "Adlabs Imagica is the main destination for travellers planning a fun-filled outing from Pune. A private Innova Crysta provides comfortable transportation for families and groups, with spacious seating and convenient travel arrangements for reaching the theme park and returning after a full day of activities."
},
{
title: "Imagica Water Park",
description: "Imagica Water Park is a popular attraction for families and groups visiting the Imagica entertainment destination. Travelling by Innova Crysta from Pune offers a practical way to carry personal belongings and enjoy a private, air-conditioned journey before and after spending the day at the water park."
},
{
title: "Khopoli",
description: "Khopoli is located close to Imagica and serves as a useful stop for travellers exploring the surrounding region. A private cab allows passengers to conveniently combine their Imagica visit with nearby sightseeing while maintaining a comfortable and flexible travel schedule."
},
{
title: "Khalapur",
description: "Khalapur is the area associated with the Imagica destination and provides convenient access to the theme park from the Pune side. An Innova Crysta is suitable for families and groups who want direct private transportation with comfortable seating and enough space for their belongings."
},
{
title: "Karla Caves",
description: "Karla Caves are historic rock-cut caves located near Lonavala and can be included in an extended Pune to Imagica sightseeing plan. A private Innova Crysta makes it easier for families and groups to combine the theme park visit with historical attractions along the route."
},
{
title: "Bhaja Caves",
description: "Bhaja Caves are an important historical attraction near Lonavala and provide another sightseeing option for travellers visiting Imagica. With a private cab, passengers can plan suitable additional stops around their theme park itinerary while travelling together in a spacious vehicle."
},
{
title: "Lonavala",
description: "Lonavala is a popular hill destination that can be combined with an Imagica outing for travellers looking for a longer day trip or weekend itinerary. The Innova Crysta provides comfortable transportation for families and groups travelling between Pune, Lonavala and the Imagica area."
},
{
title: "Khandala",
description: "Khandala is a scenic hill destination close to the Pune-Mumbai travel corridor and can be added to a broader Imagica sightseeing plan. A private Innova Crysta gives travellers flexibility to visit suitable viewpoints and attractions without relying on fixed shared transport schedules."
},
{
title: "Pawna Lake",
description: "Pawna Lake is a scenic destination near the Lonavala region and can be considered for travellers extending their Imagica trip into a weekend outing. An Innova Crysta offers useful space for families and groups travelling with personal belongings during a longer sightseeing itinerary."
},
{
title: "Tiger Point, Lonavala",
description: "Tiger Point is a well-known scenic viewpoint around Lonavala and can be included in a combined Imagica and hill-station travel plan. Private cab transportation makes it convenient to organize the route around the theme park visit and additional sightseeing preferences."
}
],
services: [
{
name: "Pune to Imagica Innova Crysta Cab",
description: "Pune to Imagica Innova Crysta Cab provides a spacious private vehicle for families and groups travelling to the popular theme park. The air-conditioned cabin, comfortable seating and luggage space make it suitable for a full-day outing or weekend trip from Pune."
},
{
name: "Pune to Adlabs Imagica Innova Crysta Taxi",
description: "Pune to Adlabs Imagica Innova Crysta Taxi offers convenient private transportation for travellers visiting Adlabs Imagica. The vehicle provides a comfortable road journey for families, friends and groups who prefer travelling together with a dedicated driver."
},
{
name: "Pune Imagica Innova Crysta Cab Booking",
description: "Pune Imagica Innova Crysta Cab Booking is suitable for passengers who want to reserve a spacious cab for their planned theme park visit. The private vehicle can accommodate families and groups while providing convenient pickup and return travel from Pune."
},
{
name: "Pune Imagica Innova Crysta Rental",
description: "Pune Imagica Innova Crysta Rental provides a practical vehicle option for travellers planning a day trip or weekend outing to Imagica. The spacious cabin and air conditioning help make the journey comfortable while allowing passengers to keep their belongings safely with them."
},
{
name: "Pune to Imagica Innova Crysta on Rent",
description: "Pune to Imagica Innova Crysta on Rent offers private transportation for families and groups travelling from Pune to the theme park. The Innova Crysta provides comfortable seating, useful luggage capacity and a dedicated travel arrangement for the complete outing."
},
{
name: "Pune to Imagica Innova Crysta Hire",
description: "Pune to Imagica Innova Crysta Hire is a convenient choice for travellers who want a dedicated vehicle for their Imagica visit. The service is suitable for one-day outings, weekend plans and group travel where passengers prefer comfortable private transportation."
},
{
name: "Pune Imagica AC Innova Crysta Cab",
description: "Pune Imagica AC Innova Crysta Cab provides an air-conditioned cabin for a comfortable journey between Pune and Imagica. The spacious interiors are useful for families and groups travelling together, particularly during a full-day theme park outing."
},
{
name: "Pune Imagica Luxury Innova Crysta Cab",
description: "Pune Imagica Luxury Innova Crysta Cab offers a premium-feel private travel experience for families and groups visiting the theme park. Comfortable seating, air conditioning and a dedicated vehicle make the journey convenient from pickup in Pune through the return trip."
},
{
name: "Pune to Imagica 7 Seater Innova Crysta",
description: "Pune to Imagica 7 Seater Innova Crysta is suitable for families and small groups wanting to travel together in one spacious vehicle. The seating arrangement provides room for passengers and personal belongings, making it practical for a complete theme park day."
},
{
name: "Pune Imagica One Way Innova Crysta Cab",
description: "Pune Imagica One Way Innova Crysta Cab is useful for travellers who need private transportation from Pune to the Imagica destination without requiring a standard return arrangement. The spacious vehicle offers comfortable seating for families and groups during the transfer."
},
{
name: "Pune Imagica Round Trip Cab",
description: "Pune Imagica Round Trip Cab provides transportation from Pune to Imagica and back, making it convenient for travellers planning a complete day at the theme park. The private cab allows the group to travel together and coordinate return travel after the day's activities."
},
{
name: "Pune Imagica Outstation Innova Crysta",
description: "Pune Imagica Outstation Innova Crysta offers a comfortable private vehicle for travel outside Pune to the Imagica area. It is suitable for families and groups requiring air-conditioned seating, luggage space and a dedicated driver for their theme park outing."
},
{
name: "Pune Imagica Family Trip Cab",
description: "Pune Imagica Family Trip Cab is designed for families planning a convenient visit to the theme park. The Innova Crysta provides comfortable seating and space for personal belongings, helping parents and children travel together in a private vehicle."
},
{
name: "Pune Imagica Group Travel Cab",
description: "Pune Imagica Group Travel Cab is suitable for friends, relatives and small groups visiting Imagica together. A spacious Innova Crysta keeps the group in one vehicle and provides a comfortable travel arrangement for the journey from Pune and the return trip."
},
{
name: "Affordable Pune Imagica Innova Crysta Cab",
description: "Affordable Pune Imagica Innova Crysta Cab provides a practical private travel option for passengers planning a theme park outing without using shared transportation. The vehicle combines comfortable seating, useful luggage capacity and convenient pickup arrangements for families and groups."
},
{
name: "Pune Imagica Theme Park Cab",
description: "Pune Imagica Theme Park Cab provides dedicated transportation for travellers visiting the Imagica entertainment destination. The Innova Crysta is suitable for families and groups who want an air-conditioned vehicle for travelling to the park and returning after a full day of activities."
},
{
name: "Pune Adlabs Imagica Family Cab",
description: "Pune Adlabs Imagica Family Cab offers a convenient private travel arrangement for families visiting Adlabs Imagica. Spacious seating and luggage capacity make the Innova Crysta useful for parents and children travelling together for a full-day or weekend outing."
},
{
name: "Pune Imagica Weekend Trip Cab",
description: "Pune Imagica Weekend Trip Cab is suitable for travellers planning a weekend escape to the theme park and nearby destinations. A private Innova Crysta provides the flexibility to include suitable sightseeing stops around Lonavala, Khopoli and the Imagica area."
},
{
name: "Pune Imagica Sightseeing Cab",
description: "Pune Imagica Sightseeing Cab is useful for travellers who want to combine their theme park visit with nearby attractions. The private Innova Crysta allows families and groups to organize additional stops according to their available time and sightseeing preferences."
},
{
name: "Pune Imagica Innova Crysta Taxi Service",
description: "Pune Imagica Innova Crysta Taxi Service provides spacious and comfortable transportation from Pune to Imagica. The service is suitable for one-day trips, family outings and group travel, with an air-conditioned vehicle and dedicated driver for a convenient journey."
},
{
name: "Pune Imagica Cab Near Me",
description: "Pune Imagica Cab Near Me is useful for travellers searching for convenient private transportation to the Imagica theme park. An Innova Crysta provides comfortable seating and sufficient space for families or groups starting their outing from Pune."
},
{
name: "Pune Imagica Private Cab",
description: "Pune Imagica Private Cab gives travellers a dedicated vehicle without sharing the journey with unrelated passengers. Families and groups can travel together, carry their personal belongings comfortably and coordinate their return according to the day's theme park schedule."
},
{
name: "Pune Imagica Innova Crysta Cab Hire",
description: "Pune Imagica Innova Crysta Cab Hire offers a spacious private vehicle for travellers planning a visit to Imagica. The service is suitable for families, friends and groups who want comfortable transportation with flexible travel arrangements for the complete outing."
},
{
name: "Pune Imagica Rental Car with Driver",
description: "Pune Imagica Rental Car with Driver provides a convenient transportation arrangement for passengers who prefer dedicated driving support during their theme park trip. The Innova Crysta offers comfortable seating and luggage space for families and groups travelling from Pune."
},
{
name: "Pune Imagica One Day Trip Cab",
description: "Pune Imagica One Day Trip Cab is designed for travellers planning a complete same-day outing from Pune to the theme park and back. A private Innova Crysta makes the journey easier to coordinate while providing comfortable seating for families and groups."
}
],
tableData: [
["Pune to Imagica Innova Crysta Cab"],
["Pune to Adlabs Imagica Innova Crysta Taxi"],
["Pune Imagica Innova Crysta Cab Booking"],
["Pune Imagica Innova Crysta Rental"],
["Pune to Imagica Innova Crysta on Rent"],
["Pune to Imagica Innova Crysta Hire"],
["Pune Imagica AC Innova Crysta Cab"],
["Pune Imagica Luxury Innova Crysta Cab"],
["Pune to Imagica 7 Seater Innova Crysta"],
["Pune Imagica One Way Innova Crysta Cab"],
["Pune Imagica Round Trip Cab"],
["Pune Imagica Outstation Innova Crysta"],
["Pune Imagica Family Trip Cab"],
["Pune Imagica Group Travel Cab"],
["Affordable Pune Imagica Innova Crysta Cab"],
["Pune Imagica Theme Park Cab"],
["Pune Adlabs Imagica Family Cab"],
["Pune Imagica Weekend Trip Cab"],
["Pune Imagica Sightseeing Cab"],
["Pune Imagica Innova Crysta Taxi Service"],
["Pune Imagica Cab Near Me"],
["Pune Imagica Private Cab"],
["Pune Imagica Innova Crysta Cab Hire"],
["Pune Imagica Rental Car with Driver"],
["Pune Imagica One Day Trip Cab"]
],
whychoose: [
{
WhyChooseheading: "Spacious Vehicle for Theme Park Outings",
WhyChoosedescription: "The Innova Crysta offers generous passenger space for families and groups travelling to Imagica from Pune. Comfortable seating and practical luggage capacity make it convenient to carry personal belongings during a complete day at the theme park."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "An air-conditioned cabin provides a comfortable environment throughout the Pune to Imagica journey. This is especially useful for families travelling with children or groups spending several hours on the road during a full-day outing."
},
{
WhyChooseheading: "Private Family-Friendly Journey",
WhyChoosedescription: "A dedicated private cab allows families to travel together without sharing the vehicle with other passengers. Parents can keep their belongings organized and coordinate the journey around the group's preferred pickup and return schedule."
},
{
WhyChooseheading: "Convenient Round Trip Planning",
WhyChoosedescription: "For a complete theme park visit, round-trip transportation keeps the return journey organized after the day's activities. The group can travel back to Pune together without arranging separate transportation after leaving Imagica."
},
{
WhyChooseheading: "Suitable for Weekend Trips",
WhyChoosedescription: "The spacious Innova Crysta works well for weekend outings that combine Imagica with Lonavala, Khopoli or nearby attractions. Private transportation gives travellers greater flexibility when planning multiple stops around their theme park visit."
},
{
WhyChooseheading: "Useful for Groups",
WhyChoosedescription: "Friends, relatives and small groups can travel together in one Innova Crysta instead of arranging separate vehicles. This simplifies coordination and provides a comfortable shared travel experience throughout the Pune to Imagica journey."
},
{
WhyChooseheading: "Dedicated Driver Support",
WhyChoosedescription: "With a dedicated driver handling the road journey, passengers can focus on enjoying their outing rather than managing the drive. This makes the private cab arrangement convenient for families and groups unfamiliar with the route."
},
{
WhyChooseheading: "Flexible Sightseeing Options",
WhyChoosedescription: "Travellers can plan additional sightseeing around the Imagica area when time permits. A private Innova Crysta allows the itinerary to include suitable attractions such as Lonavala, Khandala or nearby destinations according to the group's plans."
}
]
};













const faqData = [
{
question: "Can I book an Innova Crysta from Pune to Adlabs Imagica?",
answer: "Families, friends, and small groups planning a trip from Pune to Adlabs Imagica can enquire about an Innova Crysta cab. Citysky Cabs can arrange the journey according to your pickup location, travel date, passenger count, luggage requirements, and preferred return timing."
},
{
question: "Is Innova Crysta suitable for a Pune to Adlabs Imagica trip?",
answer: "An Innova Crysta can be a convenient option for groups travelling together to Adlabs Imagica. Having a private vehicle allows everyone to start the journey from the same pickup point, travel together, and coordinate the return after spending the day at the amusement and entertainment park."
},
{
question: "Can I book a round-trip Innova Crysta for Adlabs Imagica from Pune?",
answer: "Visitors planning a full-day outing can enquire about a round-trip Innova Crysta from Pune to Adlabs Imagica. The booking can be discussed around your preferred departure time, expected duration at the destination, passenger count, and approximate return schedule."
},
{
question: "Can families hire an Innova Crysta for Adlabs Imagica?",
answer: "Families looking for private transportation for an Adlabs Imagica outing can consider an Innova Crysta. It can be useful when parents, children, and other relatives want to travel together rather than arranging separate vehicles for the same day trip."
},
{
question: "Can friends book an Innova Crysta for a trip to Adlabs Imagica?",
answer: "Groups of friends can arrange an Innova Crysta for a Pune to Adlabs Imagica outing when they prefer travelling together in one dedicated cab. The itinerary can be planned around the group's chosen pickup location, park visit duration, and return timing."
},
{
question: "Can I plan a same-day Pune to Adlabs Imagica cab trip?",
answer: "A same-day trip can be planned for travellers who want to leave Pune, spend the day at Adlabs Imagica, and return later. When making an enquiry, provide your preferred departure time, number of passengers, pickup area, and expected return time so the transportation can be coordinated accordingly."
},
{
question: "Can I carry bags in an Innova Crysta for an Adlabs Imagica trip?",
answer: "Passengers can mention their luggage and personal-belonging requirements while requesting the cab. This is helpful for families carrying extra bags, children's items, or other belongings for a full-day outing, allowing Citysky Cabs to understand the group's transportation needs."
},
{
question: "Can I book an Innova Crysta from Pune to Adlabs Imagica for a group outing?",
answer: "Corporate teams, college groups, families, and friend circles can enquire about an Innova Crysta for a group outing to Adlabs Imagica. A dedicated vehicle helps everyone follow a common travel schedule and reduces the need to coordinate multiple cars during the trip."
},
{
question: "Can I include nearby places with my Pune to Adlabs Imagica cab booking?",
answer: "Travellers interested in combining the Adlabs Imagica visit with nearby attractions can discuss a customized route while making the cab enquiry. The final itinerary can be planned according to the available time, additional destinations, passenger count, and preferred return schedule."
},
{
question: "How can I book a Pune to Adlabs Imagica Innova Crysta Cab with Citysky Cabs?",
answer: "To enquire about the cab, share your Pune pickup location, travel date, passenger count, luggage details, preferred departure time, and whether you require one-way or round-trip transportation. Citysky Cabs can coordinate the Innova Crysta booking according to your Adlabs Imagica outing plan."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohit Chavan",
feedback:
"We planned a weekend outing to Adlabs Imagica with our children and a few relatives, so we wanted everyone to travel in the same car. The Innova Crysta was a practical choice for our group and bags. Citysky Cabs arranged the pickup according to our schedule, and having a private cab made the day trip much easier to coordinate.",
rating: 5
},
{
id: 2,
name: "Miss. Snehal Wagh",
feedback:
"A group of friends decided to visit Adlabs Imagica from Pune for a full-day outing. Instead of taking separate cars, we went with an Innova Crysta and travelled together from pickup to return. The booking process with Citysky Cabs was straightforward, and the cab arrangement suited the timing we had planned for the trip.",
rating: 5
}
];













































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Adlabs Imagica Innova Crysta Cab",
  "image": "https://www.cityskycab.in/assets/images/pune-to-adlabs-imagica-innova-crysta-cab.webp",
  "description": "Pune to Adlabs Imagica Innova Crysta Cab from Citysky Cabs is a comfortable private travel option for families, friends and groups planning a day trip or weekend visit to Imagica. The service includes Pune to Imagica Innova Crysta Cab, Adlabs Imagica Innova Crysta Taxi, booking, rental, on-rent and hire options, along with AC and luxury vehicle choices. A spacious 7-seater Innova Crysta provides comfortable seating and useful luggage capacity, making it convenient for families travelling with children, bags and personal belongings. Passengers can arrange one-way or return travel according to their park visit schedule, with pickup from Pune and a dedicated cab that allows flexible departure and return timings.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-adlabs-imagica-innova-crysta-cab"
  }
};









    return (
        <div>

<Helmet>
  <title>
    Pune to Adlabs Imagica Innova Crysta Cab | Spacious 7 Seater Crysta for Family Theme Park Trips | +91 8554819191
  </title>

  <meta
    name="description"
    content="Travel from Pune to Adlabs Imagica in a spacious AC 7-seater Innova Crysta with Citysky Cabs. Ideal for family outings, weekend trips, groups and convenient one-way or return travel."
  />

  <meta
    name="keywords"
    content="Pune to Imagica Innova Crysta Cab, Pune to Adlabs Imagica Innova Crysta Taxi, Pune Imagica Innova Crysta Cab Booking, Pune Imagica Innova Crysta Rental, Pune to Imagica Innova Crysta on Rent, Pune to Imagica Innova Crysta Hire, Pune Imagica AC Innova Crysta Cab, Pune Imagica Luxury Innova Crysta Cab, Pune to Imagica 7 Seater Innova Crysta, Pune Imagica One Way Innova Crysta Cab, Pune Imagica Round Trip Innova Crysta Cab, Pune to Adlabs Imagica Innova Crysta Cab, Pune Imagica Theme Park Taxi, Pune Imagica Family Cab, Pune Imagica Weekend Cab, Pune Imagica Group Taxi, Pune Imagica Outstation Cab, Pune Imagica Private Cab, Pune Imagica Return Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoadlabasimagicainnova;